import React from 'react';

import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { cssMap, cx } from '@atlaskit/css';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import ChartTrendUpIcon from '@atlaskit/icon/core/chart-trend-up';
import { token } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';

const styles = cssMap({
	badge: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: token('space.050'),

		color: token('color.text.subtle'),
		font: token('font.body.small'),
		backgroundColor: token('elevation.surface'),
		borderRadius: token('radius.small'),
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
		paddingTop: token('space.025'),
		paddingBottom: token('space.025'),
		height: '24px',
		transition: token('motion.button.hovered'),

		'&:hover': {
			backgroundColor: token('color.background.neutral.subtle.hovered'),
		},
		'&:active': {
			backgroundColor: token('color.background.neutral.subtle.pressed'),
			transition: token('motion.button.pressed'),
		},
	},
	open: {
		backgroundColor: token('color.background.neutral.subtle.hovered'),
	},
	motion: {
		transition: token('motion.button.hovered'),
		'&:active': {
			transition: token('motion.button.pressed'),
		},
	},
});

type BadgeStyleAnalyticsBylineProps = {
	message: React.ReactNode | string;
	onClick?: (e: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
	iconLabel: string;
	isOpen?: boolean;
};

export const BadgeStyleAnalyticsByline = ({
	message,
	onClick,
	iconLabel,
	isOpen,
}: BadgeStyleAnalyticsBylineProps): React.JSX.Element => (
	<Pressable
		onClick={onClick}
		xcss={cx(
			styles.badge,
			fg('platform-dst-motion-uplift-custom-button') && styles.motion,
			isOpen && fg('confluence_byline_analytics_popup_layout') && styles.open,
		)}
		testId="badge-style-analytics-byline"
	>
		<ChartTrendUpIcon label={iconLabel} />
		{message}
	</Pressable>
);
